import { render, staticRenderFns } from "./RecentView.vue?vue&type=template&id=42679bce&scoped=true"
import script from "./RecentView.vue?vue&type=script&lang=js"
export * from "./RecentView.vue?vue&type=script&lang=js"
import style0 from "./RecentView.vue?vue&type=style&index=0&id=42679bce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42679bce",
  null
  
)

export default component.exports